import Main from '../../containers/Main/Main';

const AllRentList = () => {
	return <Main>asdsad</Main>;
};

export default AllRentList;
